import { render, staticRenderFns } from "./bar-chart-horizontal.vue?vue&type=template&id=a4ac45b2&scoped=true&"
import script from "./bar-chart-horizontal.vue?vue&type=script&lang=js&"
export * from "./bar-chart-horizontal.vue?vue&type=script&lang=js&"
import style0 from "./bar-chart-horizontal.vue?vue&type=style&index=0&id=a4ac45b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4ac45b2",
  null
  
)

export default component.exports